import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { userService } from "./user.service";
import { clearAlertWithDelay, setAlertError } from "../alert/alert.slice";

const initialState = {
  user: {
    loading: false,
    submitions: [],
  },
};

export const getUserSubmitions = createAsyncThunk(
  "user/submitions/get",
  async (userId, thunkAPI) => {
    const response = await userService.getUserSubmitions(userId);
    return { data: response.data.submitions };
  }
);

export const createUserOrUpdateUser = createAsyncThunk(
  "/submition/create",
  async (user, thunkAPI) => {
    try {
      const response = await userService.create(user);
      return response.data.user;
    } catch (err) {
      thunkAPI.dispatch(
        setAlertError(
          "Your information could not get saved, please check your internet connection and try again."
        )
      );
      thunkAPI.dispatch(clearAlertWithDelay());
      return thunkAPI.rejectWithValue(err);
    }
  }
);

export const verifyUserOTP = createAsyncThunk(
  "/user/verify",
  async (user, thunkAPI) => {
    try {
      const response = await userService.verifyUserOTP(user);
      return response.data;
    } catch (err) {
      thunkAPI.dispatch(
        setAlertError(
          "Something went wrong while trying to verify your email, please try again"
        )
      );
      thunkAPI.dispatch(clearAlertWithDelay());
      return thunkAPI.rejectWithValue(err);
    }
  }
);

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    saveUser: (state, action) => {
      state.data = action.payload;
    },
    resetUser: (state, action) => {
      state.user = initialState;
      state.data = {};
    },
  },
  extraReducers: {
    [getUserSubmitions.fulfilled]: (state, action) => {
      state.user.loading = false;
      state.submitions = action.payload.data;
    },
    [getUserSubmitions.pending]: (state, action) => {
      state.user.loading = true;
    },
    [createUserOrUpdateUser.fulfilled]: (state, action) => {
      state.user = { loading: false, ...action.payload };
    },
    [createUserOrUpdateUser.pending]: (state, action) => {
      state.user = { loading: true };
    },
    [createUserOrUpdateUser.rejected]: (state, action) => {
      state.user = { loading: false, ...action.payload };
    },
    [verifyUserOTP.fulfilled]: (state, action) => {
      state.user = { loading: false, updating: false, ...action.payload };
    },
    [verifyUserOTP.rejected]: (state, action) => {
      state.user = { loading: false, updating: false, ...action.payload };
    },
    [verifyUserOTP.pending]: (state, action) => {
      state.user = { updating: true, loading: true };
    },
  },
});

export const { resetUser, saveUser } = userSlice.actions;

export default userSlice.reducer;
